import { handleColorType } from '@quizzach/styles';
import { useTheme } from 'styled-components';

export const EndFlag = ({
	color,
	size,
	className,
}: {
	color?: string;
	size?: number;
	className?: string;
}) => {
	const theme = useTheme();

	return (
		<svg
			width={size || '42'}
			height={size || '42'}
			viewBox='0 0 42 42'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
			className={className}
		>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M9 1C9 0.447708 8.55229 0 8 0C7.44771 0 7 0.447708 7 1V41C7 41.5523 7.44771 42 8 42C8.55229 42 9 41.5523 9 41V30.0276C9.55865 30.3504 10.2714 30.4084 10.9222 30.0702L34.5846 17.7749C36.0217 17.0282 36.0217 14.9722 34.5846 14.2255L10.9222 1.93013C10.2714 1.59198 9.55865 1.64993 9 1.97278V1ZM14.8142 18.7235L14.8783 18.7412C15.1453 18.815 15.2548 18.8453 15.4768 18.8755C15.5029 18.8791 15.5334 18.8846 15.5669 18.8906C15.8401 18.94 16.3111 19.025 16.2047 18.3867C16.0852 17.6697 15.9222 17.6154 15.7484 17.5828C15.5746 17.5502 15.3202 17.4843 15.2487 17.4524L15.2212 17.4387C14.9385 17.298 14.8049 17.2314 14.7081 16.9788C14.6082 16.7182 14.6009 16.3462 14.6861 15.8629L15.2379 12.7336C15.3376 12.1679 15.4565 11.7695 15.5944 11.5387C15.7441 11.3098 15.9795 11.1812 16.3005 11.1527C16.6333 11.1263 17.1651 11.1776 17.8958 11.3064C18.5205 11.4166 18.9778 11.5458 19.2676 11.6941C19.5595 11.8307 19.7474 12.04 19.8313 12.3222C19.9173 12.5926 19.9126 12.9989 19.817 13.541L19.2652 16.6704C19.2599 16.7005 19.2543 16.7301 19.2487 16.7593L18.7671 19.3753C18.7006 19.7072 19.4831 20.28 19.8044 20.3386C20.1262 20.3954 20.2843 20.1683 20.344 19.8535L21.4455 13.6095C21.6201 12.6194 21.4561 11.8613 20.9533 11.3351C20.4527 10.7972 19.5187 10.4077 18.1515 10.1666C16.7135 9.91304 15.6438 9.94923 14.9422 10.2752C14.2545 10.5914 13.8233 11.2446 13.6487 12.2347L13.0907 15.3994C12.9951 15.9415 12.9751 16.3998 13.0306 16.7742C13.084 17.1604 13.1863 17.4762 13.3375 17.7216C13.4887 17.967 13.713 18.1767 14.0105 18.3506C14.0457 18.3703 14.0796 18.3894 14.1127 18.4079C14.3488 18.5408 14.5381 18.6473 14.8142 18.7235ZM18.2771 21.3939C18.3288 21.101 18.4283 20.7135 18.7212 20.7652C19.0141 20.8168 19.9257 21.3522 19.8741 21.6451L19.7773 22.1948C19.7256 22.4877 19.4463 22.6833 19.1534 22.6317L18.6222 22.5381C18.3293 22.4864 18.1337 22.2071 18.1854 21.9141L18.2771 21.3939Z'
				fill={color ? handleColorType(color, theme) : '#00FFC2'}
			/>
		</svg>
	);
};
